module.exports = __webpack_public_path__ + "img/app-icons.721939a6.svg";